import { criarParticipante } from '@/uteis/action/tramite/participante'

export const criarFinalizador = (dadosSessao, isAdicionarUsuario) => {
  var finalizador = criarParticipante(dadosSessao.nomeUsuario, dadosSessao.login, 'LOGIN')
  var departamento = criarParticipante(dadosSessao.descricaoDepartamento, dadosSessao.idDepartamento, 'ID', dadosSessao.siglaDepartamento)
  var orgao = criarParticipante(dadosSessao.descricaoOrgao, dadosSessao.idOrgao, 'ID', dadosSessao.siglaOrgao)

  if (isAdicionarUsuario) {
    finalizador.participantePai = departamento
  } else {
    finalizador = departamento
  }

  departamento.participantePai = orgao

  return finalizador
}
